import { useSelector } from 'react-redux'

import { useGetEnterpriseSupportQuery } from 'api/rtkQueryApi/platform/organizationsApi'
import { RootState } from 'app/rootReducer'

export const useEnterpriseSupport = (): boolean => {
  const { currentOrganization } = useSelector((state: RootState) => state.app)
  const enterpriseSupportQuery = useGetEnterpriseSupportQuery(undefined, { skip: !currentOrganization })

  return enterpriseSupportQuery.data?.isSupported ?? false
}
